(() => {
  if (!['glovia-elegante-romantique', 'snow-globe'].some(handle => location.pathname.includes('/collections/' + handle))) return;
  let active = false;
  let busy = false;
  let timer;
  function imageFor(card) { return card.querySelector('[data-led-card-url]'); }
  function control() { return document.querySelector('[data-glovia-led-control]'); }
  function cards() { return [...document.querySelectorAll('#product-grid .product-card-wrapper')]; }
  function render() {
    const root = control();
    if (!root) return;
    const button = root.querySelector('button');
    button.setAttribute('aria-checked', String(active));
    button.disabled = busy;
    root.querySelector('[data-led-label]').textContent = active ? root.dataset.dayLabel : root.dataset.nightLabel;
    root.querySelector('[data-led-status]').textContent = busy ? root.dataset.loadingLabel : active ? root.dataset.nightStatus : root.dataset.dayStatus;
    cards().forEach(card => {
      const source = imageFor(card);
      const media = card.querySelector('.card__media .media');
      if (!media || !source) return;
      if (!media.querySelector('.glovia-led-photo')) {
        const image = document.createElement('img');
        image.className = 'glovia-led-photo motion-reduce';
        image.src = source.dataset.ledCardUrl;
        image.alt = source.dataset.ledCardAlt;
        image.width = 720;
        image.height = 960;
        image.loading = active ? 'eager' : 'lazy';
        image.setAttribute('aria-hidden', String(!active));
        media.append(image);

      }
      card.classList.toggle('glovia-led-active', active);
      media.querySelector('.glovia-led-photo').setAttribute('aria-hidden', String(!active));
    });
    root.hidden = !cards().some(card => imageFor(card));
  }
  document.addEventListener('click', async event => {
    if (!event.target.closest('[data-glovia-led-control] button') || busy) return;
    if (active) { active = false; render(); return; }
    busy = true;
    render();
    const current = cards().map(card => card.querySelector('.glovia-led-photo')).filter(Boolean);
    current.forEach(image => image.loading = 'eager');
    const results = await Promise.allSettled(current.map(image => image.decode()));
    busy = false;
    if (results.every(result => result.status === 'fulfilled')) {
      active = true;
      render();
    } else {
      render();
      const root = control();
      if (root) root.querySelector('[data-led-status]').textContent = root.dataset.errorLabel;
    }
  });
  render();
  const main = document.getElementById('MainContent');
  if (main) new MutationObserver(mutations => {
    if (!mutations.some(m => [...m.addedNodes, ...m.removedNodes].some(n => n.nodeType === 1))) return;
    clearTimeout(timer);
    timer = setTimeout(render, 40);
  }).observe(main, { childList: true, subtree: true });
})();